import React from 'react';
import {withStyles, makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import Delete from '@material-ui/icons/Delete';
import MoreVert from '@material-ui/icons/MoreVert';
import Edit from '@material-ui/icons/Edit';
import FileCopy from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CollapseC from '@material-ui/core/Collapse';
import Tooltip from '@material-ui/core/Tooltip';
import { StyledTableCellHead } from './tableStyles';

const StyledTableCell = withStyles((theme) => ({
  root: (props) => ({
    padding: 0,
    '&:last-child':{
      borderBottom: props.isHeader ? 'none' : '1px solid rgba(224, 224, 224, 1) !important',
      borderRight: props.isHeader ? '2px solid rgb(63, 78, 92)' :'2px solid rgba(224, 224, 224, 1)'
    }
  }),
  head: ({reverse}) => {
    if (reverse) return {color: theme.palette.common.black, backgroundColor: '#C4C4C4' || theme.palette.common.white};
    return {backgroundColor: theme.palette.primary.main, color: theme.palette.common.white};
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    // minWidth: 700,
  },
});

export default function CustomizedTables(props) {
  const classes = useStyles();
  const {headers, actions, size, reverse, collapse, style = {}, stickyHeader, id, dataUiTourId} = props;

  let componentProps = {
    tableContainer: {},
    table: {style},
  };

  if (stickyHeader) {
    componentProps = {
      tableContainer: {...componentProps.tableContainer, style: {maxHeight: 150}},
      table: {...componentProps.table, stickyHeader: true},
    };
  }
  return (
    <TableContainer
      data-ui-tour-id={dataUiTourId}
      component={Paper}
      style={{boxShadow: 'none', borderRadius: '0'}}
      {...componentProps.tableContainer}>
      <Table {...componentProps.table} id={id} size={size} className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            {collapse && <StyledTableCell reverse={reverse} align="right" />}
            {headers.map((header) => {
              return (
                <StyledTableCellHead style={{padding: '5px 10px !important'}} reverse={reverse} key={header._id} align="left" /*{header.align || 'inherit'}*/>
                  {header.label}
                </StyledTableCellHead>
              );
            })}
            {actions && <StyledTableCell isHeader reverse={reverse} align="right"/>}
          </TableRow>
        </TableHead>
        <TableBody>{props.children}</TableBody>
      </Table>
    </TableContainer>
  );
}

CustomizedTables.defaultProps = {
  size: 'medium',
  children: <React.Fragment />,
  actions: false,
  collapse: false,
  reverse: false,
  headers: [
    {_id: 'h1', label: 'Header one'},
    {_id: 'h2', label: 'Header two', align: 'right'},
    {_id: 'h3', label: 'Header three', align: 'right'},
    {_id: 'h4', label: 'Header four', align: 'right'},
  ],
};

CustomizedTables.propTypes = {
  children: PropTypes.node,
  headers: PropTypes.array,
  actions: PropTypes.bool,
  collapse: PropTypes.bool,
  reverse: PropTypes.bool,
  size: PropTypes.string,
};

export const Row = StyledTableRow;
export const Cell = StyledTableCell;

export const Action = (props) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const {options, onMenuClick, index, showCloneBtn=true} = props;

  let filteredOptions = options
  if(!showCloneBtn){
    filteredOptions = options.filter(item => item._id != "clone")
  }


  const onMenuItemClick = (value) => {
    onMenuClick(value);
    handleClose();
  };

  const {deleteOnly, edit, clone} = props;
  

  const capitaliseTooltipValue = (value) => value.charAt(0).toUpperCase() + value.slice(1);

  return (
    <React.Fragment>
      <Cell key="action" align="right" style={{borderRight: "2px solid 2px solid rgba(224, 224, 224, 1)", borderBottom: 'none'}}>
        {deleteOnly ? (
          <React.Fragment>
            {edit && (
              <IconButton size="small" aria-label="more" aria-haspopup="true" onClick={() => onMenuClick('edit')}>
                <Edit />
              </IconButton>
            )}

            {clone && (
              <IconButton size="small" aria-label="more" aria-haspopup="true" onClick={() => onMenuClick('clone')}>
                <FileCopy />
              </IconButton>
            )}

            <IconButton size="small" aria-label="more" aria-haspopup="true" onClick={() => onMenuClick('delete')}>
              <Delete color="error" />
            </IconButton>
          </React.Fragment>
        ) : (
          <IconButton size="small" aria-label="more" aria-haspopup="true" onClick={handleClick}>
            <MoreVert />
          </IconButton>
        )}
      </Cell>
      <Menu id={`config-action-menu-${index}`} anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        {filteredOptions.map((option) => (       
            <Item key={option._id} value={option._id} onClick={onMenuItemClick}>
                <Tooltip title={capitaliseTooltipValue(option._id)} placement='left'>
                  {
                    option._id === "edit" ? <Edit/>
                    : option._id === "clone" ? <FileCopy/>
                    : <Delete/> 
                  }
                </Tooltip>
            </Item>             
        ))}
      </Menu>
    </React.Fragment>
  );
};

const Item = ({onClick, value, children}) => {
  const onMenuPress = () => onClick(value);
  return (
    <React.Fragment>
      <MenuItem onClick={onMenuPress}>{children}</MenuItem>
    </React.Fragment>
  );
};

Action.defaultProps = {
  options: [
    {_id: 'edit', label: 'Edit'},
    {_id: 'delete', label: 'Delete'},
    {_id: 'clone', label: 'Clone'}
  ],
  deleteOnly: false,
  onMenuClick: () => {},
};

Action.propTypes = {
  options: PropTypes.array.isRequired,
  deleteOnly: PropTypes.bool.isRequired,
};

// PaperProps={{
//   style: {
//     maxHeight: 48 * 4.5,
//   },
// }}

export const Collapse = (props) => {
  const {open, colSpan} = props;
  return (
    <TableRow style={{padding: '1rem'}}>
      <TableCell style={{paddingBottom: 0, paddingTop: 0, padding: 0}} colSpan={colSpan || 6} >
        <CollapseC in={open} timeout="auto" unmountOnExit>
          {props.children}
        </CollapseC>
      </TableCell>
    </TableRow>
  );
};
